import { render } from "./confirm-page.vue?vue&type=template&id=6333815c&scoped=true&ts=true"
import script from "./confirm-page.ts?vue&type=script&lang=ts&external"
export * from "./confirm-page.ts?vue&type=script&lang=ts&external"

import "./confirm-page.less?vue&type=style&index=0&id=6333815c&lang=less&scoped=true&external"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6333815c"]])

export default __exports__
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSeparator,QCard,QCardSection,QField});
